import { GetOrderGroupResponseResultData, PostOrderGroupRequest } from '@/coreInfrastructureModule/axios/generated/orderGroupManage';
import { IOrderGroup } from '../../coreDomainsModule/entities/IOrderGroup';
import { OrderGroupFactory } from '@/coreDomainsModule/factories/OrderGroupFactory';

/**
 * OrderGroupのアダプタ
 */
export class OrderGroupAdapter {
  /**
   * IOrderGroupから発注グループ生成APIリクエストを生成
   * @param request - 新規登録する発注グループデータ
   * @returns - 発注グループ生成APIリクエスト
   */
  public static adaptPostOrderGroup = (request: IOrderGroup): PostOrderGroupRequest => {
    return {
      postOrderGroupInfo: {
        orderGroupName: request.orderGroupName,
        invoiceNumber: request.invoiceNumber === '' ? undefined : request.invoiceNumber,
        destinationName: request.destinationName === '' ? undefined : request.destinationName,
        upperLimitQuantity: request.upperLimitQuantity,
        memo: request.memo,
      },
    };
  };

  /**
   * 取得した発注グループ情報からIOrderGroupを生成する
   * @param result - 発注グループ取得のレスポンス
   * @returns - IOrderGroup型の発注グループ情報
   */
  public static adaptResponseOrderGroup = (result: GetOrderGroupResponseResultData[]): IOrderGroup[] => {
    return result.map((data) =>
      OrderGroupFactory.create({
        orderGroupId: data.orderGroupId,
        orderGroupName: data.orderGroupName,
        invoiceNumber: data.invoiceNumber,
        destinationName: data.destinationName,
        upperLimitQuantity: data.upperLimitQuantity,
        memo: data.memo,
        eta: data.eta ?? undefined,
        linkedOrderCount: data.linkedOrderCount,
        totalLinkedOrderAmount: data.totalLinkedOrderAmount,
      })
    );
  };
}
